const Lightbox = ({ label, onClose }) => {
  if (!label) return null;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- backdrop click-to-close; the Cerrar button already covers keyboard access
    <div
      role="presentation"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 80,
        background: 'rgba(28,22,25,.6)',
        backdropFilter: 'blur(6px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6vw',
      }}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- stops the backdrop's onClose from firing when clicking inside the card */}
      <div
        role="presentation"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--cream)',
          borderRadius: 'var(--radius-xl)',
          padding: 22,
          maxWidth: 560,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
        }}
      >
        <div
          style={{
            aspectRatio: '4/5',
            background: 'var(--rose-50)',
            border: '1px dashed var(--rose-300)',
            borderRadius: 'var(--radius-lg)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            textAlign: 'center',
            padding: 20,
          }}
        >
          <span style={{ fontSize: 10, letterSpacing: '.2em', textTransform: 'uppercase', color: 'var(--rose-400)' }}>
            Foto en tamaño completo
          </span>
          <span style={{ fontSize: 16, color: 'var(--rose-700)' }}>{label}</span>
        </div>
        <button
          onClick={onClose}
          style={{
            cursor: 'pointer',
            border: '1px solid var(--ink-200)',
            background: '#FFF',
            fontFamily: 'inherit',
            fontSize: 13,
            letterSpacing: '.08em',
            textTransform: 'uppercase',
            color: 'var(--ink-700)',
            padding: 12,
            borderRadius: 'var(--radius-pill)',
          }}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default Lightbox;
